import { render } from "./AllServicesView.vue?vue&type=template&id=2b70e921"
import script from "./AllServicesView.vue?vue&type=script&lang=js"
export * from "./AllServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__